import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8b03516&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b03516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8b03516')) {
      api.createRecord('a8b03516', component.options)
    } else {
      api.reload('a8b03516', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a8b03516&scoped=true&", function () {
      api.rerender('a8b03516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/zone-config/modules/table-list/index.vue"
export default component.exports